import { UserInformation } from '#/models/UserInformation';

import { doGet } from '../../helpers';

export const userInformation = {
  me: () => doGet<UserInformation>('/user-information/me')
};
